import ModelFactory from '../model-factory';
import { BaseModel } from '../models';
/**
 * format:
{
  @id: 404364
  @COMMON_NAME: "Prueba documento solo KeyUser"
  @REL_ATTR: 404364
  AVG_RATING: 2.75
  CREATION_DATE: 1588857619
  DOC_TEMPLATE_ID: 10
  HITS: 25
  MODIFY_DATE: 1588927455
  PGROUP_ID: {id: 400155}
  PRIMARY_INDEX: {@REL_ATTR: 400312, @COMMON_NAME: "Notificaciones bienvenida", @id: 400312}
  SD_ACCEPTED_HITS: 0
  STATUS_ID: 70
  SUMMARY: "Prueba documento solo KeyUser"
  z_refext: 1327
}
 */

export default class News extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.ratingAverage = data.AVG_RATING || null;
    this.creationDate = data.CREATION_DATE || null;
    this.modifyDate = data.MODIFY_DATE || null;
    this.templateId = data.DOC_TEMPLATE_ID || null;
    this.hits = data.HITS || null;
    this.summary = data.SUMMARY || null;
    this.resolution = data.RESOLUTION || null;
    this.statusId = data.STATUS_ID || null;
    this.zinfo_usuariofinal = data.zinfo_usuariofinal || null;

    this.primaryIndex = null;
    if (data.PRIMARY_INDEX != null) {
      this.primaryIndex = data.PRIMARY_INDEX['@COMMON_NAME'] || null;
    }

    this.pGroupId = null;
    if (data.PGROUP_ID != null) {
      this.pGroupId = data.PGROUP_ID.id || null;
    }
  }

  extend(newsItem) {
    this.summary = newsItem.summary;
    this.resolution = newsItem.resolution;
  }
}

export const modelFactory = new ModelFactory('KD', (data) => new News(data));
